export type SessionLogoutReason =
  | 'SESSION_VERSION_MISMATCH'
  | 'TOKEN_EXPIRED'
  | 'INVALID_REFRESH_TOKEN'
  | 'TOKEN_INVALID';

type JwtPayload = {
  exp?: number;
  jti?: string;
};

function decodeJwtPayload(token?: string | null): JwtPayload | null {
  const raw = token?.trim();
  if (!raw) {
    return null;
  }
  const parts = raw.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
    b64 += pad;
    const json = atob(b64);
    const payload = JSON.parse(json) as Record<string, unknown>;
    const exp = Number(payload['exp']);
    const jti =
      typeof payload['jti'] === 'string' && payload['jti'].trim()
        ? payload['jti'].trim()
        : undefined;
    return {
      exp: Number.isFinite(exp) ? exp : undefined,
      jti,
    };
  } catch {
    return null;
  }
}

export function getAccessTokenExpiresAtMs(
  token: string | null | undefined,
): number | null {
  const decoded = decodeJwtPayload(token);
  if (!decoded?.exp) {
    return null;
  }
  return decoded.exp * 1000;
}

export function getAccessTokenJti(token: string | null | undefined): string | null {
  const decoded = decodeJwtPayload(token);
  return decoded?.jti ?? null;
}

export function formatCountdownMmSs(remainingMs: number): string {
  const totalSec = Math.max(0, Math.ceil(remainingMs / 1000));
  const mm = String(Math.floor(totalSec / 60)).padStart(2, '0');
  const ss = String(totalSec % 60).padStart(2, '0');
  return `${mm}:${ss}`;
}
